
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vctracker.factory:TrackerHelper
   *
   * @description
   *
   */
  angular
    .module('vctracker')
    .factory('TrackerHelper', TrackerHelper);
  
  
  TrackerHelper.$inject = ['Tracker', '$uibModal', '$log', 'Rlog'];
  
  function TrackerHelper(Tracker, $uibModal, $log, Rlog) {
    let TrackerHelperBase = {};
    
    TrackerHelperBase.editTracker = editTracker;
    TrackerHelperBase.addTracker = addTracker;
    
    
    function addTracker(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackerform tracker="vm.tracker" parentsave="vm.childsave(tracker)" oncancel="vm.cancel()"></trackernew></div>',
        controllerAs: 'trackeraCtrl',
        controller: ['tracker', function () {
          let vm = this;
          vm.tracker = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(tracker) {
            Tracker.$create(tracker).$then(function (newtracker) {
              vm.created = true;
              success(newtracker);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ tracker-helper.addTracker: ', err);
              Rlog.error('vcutils.tracker', 'tracker-helper.addTracker', 'Creation of new SV failed: ', {error: err, tracker: tracker});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          tracker: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editTracker(ltracker) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackerform tracker="trackereCtrl.tracker" parentsave="trackereCtrl.childsave(tracker)" oncancel="trackereCtrl.cancel()"></trackerform></div>',
        controllerAs: 'trackereCtrl',
        controller: ['tracker', function (stracker) {
          let vm = this;
          vm.tracker = stracker;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(tracker) {
            // vm.tracker = angular.copy(tracker);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in tracker) {
              if (tracker.hasOwnProperty(key)) {
                vm.tracker[key] = tracker[key];
              }
            }
            
            if (vm.tracker.$hasPendingActions()) {
              vm.tracker.$cancel();
              vm.tracker.$save();
              cancel();
            }
            else {
              vm.tracker.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          tracker: function () {
            return ltracker;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return TrackerHelperBase;
  }
}());
